<template>
  <div class="home-page row">
    <div class="span8 page-content">
      <help-widget />
      <oldstuff-widget />
      <news-widget />
    </div>
    <div class="span4 page-sidebar">
      <carousel-widget />
      <activity-widget />
      <job-widget />
    </div>
  </div>
</template>

<script>
import helpWidget from '@/components/help.vue'
import oldstuffWidget from '@/components/oldstuff.vue'
import newsWidget from '@/components/news.vue'
import carouselWidget from '@/components/carousel.vue'
import activityWidget from '@/components/activity.vue'
import jobWidget from '@/components/job.vue'

export default {
  name: 'Home',
  components: { helpWidget, oldstuffWidget, newsWidget, carouselWidget, activityWidget, jobWidget }
}
</script>
